/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { widgetsDelete } from "../funcs/widgetsDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteWidgetRequest,
  DeleteWidgetSecurity,
} from "../models/operations/deletewidget.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteWidgetMutationVariables = {
  request: DeleteWidgetRequest;
  security?: DeleteWidgetSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteWidgetMutationData = void;

export type DeleteWidgetMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteWidget widgets
 *
 * @remarks
 * Delete a widget. Its creator can; deleting someone else's needs project write access.
 */
export function useDeleteWidgetMutation(
  options?: MutationHookOptions<
    DeleteWidgetMutationData,
    DeleteWidgetMutationError,
    DeleteWidgetMutationVariables
  >,
): UseMutationResult<
  DeleteWidgetMutationData,
  DeleteWidgetMutationError,
  DeleteWidgetMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteWidgetMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteWidget(): MutationKey {
  return ["@gram/client", "widgets", "delete"];
}

export function buildDeleteWidgetMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteWidgetMutationVariables,
  ) => Promise<DeleteWidgetMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteWidget(),
    mutationFn: function deleteWidgetMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteWidgetMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(widgetsDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
